import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MenuItem } from '@app/models';

@Injectable()
export class MenuService {
	private menuItems: MenuItem[];
	constructor(private readonly http: HttpClient) {}

	getMenuItems(): Observable<any> {
		if (this.menuItems?.length) {
			return of(this.menuItems);
		}
		return this.http.get('/api/siteClaims/menu-items');
	}

	setMenuItems(data: MenuItem[]): void {
		this.menuItems = JSON.parse(JSON.stringify(data)) as MenuItem[]; //Do this so the array coming back from the database is immutable
	}
}
